import React, { lazy, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { themeChange } from "theme-change";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";
import AuthRoute from "./AuthRoute"; // Yeni eklenen bileşen
import Swal from "sweetalert2";

// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const CustomerLayout = lazy(() => import("./containers/CustomerPage/CustomerLayout"));
const Login = lazy(() => import("./pages/Login"));
const DemandForm = lazy(() => import("./pages/DemandForm"));
const DemandCompleted = lazy(() => import("./pages/DemandCompleted"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));
const CustomerLogin = lazy(() => import("./pages/CustomerLogin"));



export const Toast = Swal.mixin({
  toast: true,
  position: 'center',
  iconColor: 'white',
  customClass: {
    popup: 'colored-toast',
  },
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
})

// Initializing different libraries
initializeApp();

// Check for login and initialize axios
const token = checkAuth();
export const api = process.env.REACT_APP_BASE_URL;
export const fileUrl = process.env.REACT_APP_FILE_BASE_URL;
const org = sessionStorage.getItem("org");

function App() {
  useEffect(() => {
    themeChange(false);
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/customerlogin" element={<CustomerLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/register" element={<Register />} />

          <Route path="/demandcompleted" element={<DemandCompleted />} />
          <Route path="/demandform" element={<DemandForm />} />

          <Route 
            path="/app/*" 
            element={
              <AuthRoute org={false}>
                <Layout />
              </AuthRoute>
            } 
          />
          <Route 
            path="/company/*" 
            element={
              <AuthRoute org={true}>
                <CustomerLayout />
              </AuthRoute>
            } 
          />

          <Route
            path="*"
            element={
              <Navigate to={token ? (org ? "/company/dashboard" : "/app/welcome") : "/login"} replace />
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
